export enum EntityStoreKey {
  TellentCurrentUser = 'tellentCurrentUser',
}
